import React, { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import styles from "./CreateFormNew.module.scss";

import { IFormInputNew, OptionsProps } from "../../types/salaries";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { selectStyles } from "../../static/styles";
import {
  getEditSalary,
  setEditSalary,
  toggleCreateModal,
} from "../../features/salaries/salariesSlice";

type Props = {
  handleSaveSalaries: (data: IFormInputNew) => void;
};

const CreateFormNew = ({ handleSaveSalaries }: Props) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const editSalary = useAppSelector(getEditSalary);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [statusTypeOption] = useState<OptionsProps[]>([
    {
      value: 1,
      label: "બોનસ",
    },
    {
      value: 2,
      label: "ઉપાડ",
    },
  ]);

  const {
    handleSubmit,
    register,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm<IFormInputNew>({
    defaultValues: { amount: null, note: null, status: null },
  });

  const handleOnSubmit: SubmitHandler<IFormInputNew> = async (data: any) => {
    setIsLoading(true);
    if (editSalary && editSalary.id) {
      await handleSaveSalaries({
        ...data,
        id: editSalary.id,
      });
    } else {
      await handleSaveSalaries({ ...data, employee_id: id });
    }
    handleCloseFormModal();
    setIsLoading(false);
  };

  const handleCloseFormModal = () => {
    reset();
    dispatch(toggleCreateModal(0));
    dispatch(setEditSalary(null));
  };

  useEffect(() => {
    if (editSalary && editSalary.id) {
      reset({
        amount: editSalary.amount,
        status: editSalary.status,
        note: editSalary.note,
      });
    } else {
      reset({ amount: null, note: null, status: null });
    }
  }, [editSalary]);

  return (
    <div className={styles.CreateFormNew}>
      <div className="relative h-[100vh] w-[100vw] overflow-y-scroll lg:overflow-auto top-0 lg:top-10 lg:mx-auto p-5 border lg:w-96 lg:h-fit shadow-lg lg:rounded-md bg-white">
        <div className="mt-3">
          <h3 className="text-2xl text-center font-bold leading-6 text-primary-1">
            ઉપાડ/બોનસ ની માહિતી
          </h3>
          <div className="mt-2 py-3">
            <form onSubmit={handleSubmit(handleOnSubmit)}>
              <div className="grid gap-4">
                <div className="mt-3">
                  <label className="text-primary-1 font-bold">
                    ઉપાડ/બોનસ ટાઈપ :
                  </label>
                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register("status", {
                        required: true,
                        min: 0,
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={
                            statusTypeOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ટાઈપ સિલેક્ટ કરો"}
                          options={statusTypeOption}
                          onChange={(val: any) =>
                            setValue("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  {errors.status && (
                    <span className="text-red-500">ટાઈપ સિલેક્ટ કરો</span>
                  )}
                </div>

                <div className="mt-3">
                  <label className="text-primary-1 font-bold">
                    ઉપાડ/બોનસ નું અમાઉન્ટ :
                  </label>
                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <input
                      className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                      type="number"
                      pattern="-?[0-9]*"
                      step={"any"}
                      placeholder="ઉપાડ/બોનસ નું અમાઉન્ટ દાખલ કરો"
                      {...register("amount", {
                        required: true,
                        min: 0,
                      })}
                      onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                    />
                  </div>
                  {errors.amount && (
                    <span className="text-red-500">
                      ઉપાડ/બોનસ નું અમાઉન્ટ દાખલ કરો
                    </span>
                  )}
                </div>

                <div className="mt-3">
                  <label className="text-primary-1 font-bold">
                    પેમેન્ટ ની નોંધ :
                  </label>
                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <input
                      className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                      type="text"
                      placeholder="નોંધ દાખલ કરો"
                      {...register("note", {
                        //   required: true,
                      })}
                    />
                  </div>
                  {errors.note && (
                    <span className="text-red-500">નોંધ દાખલ કરો</span>
                  )}
                </div>

                <div className="mt-3 text-center">
                  <button
                    className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "રાહ જુઓ..." : "આગળ વધો"}
                  </button>
                </div>

                <div className="mt-1 text-center">
                  <button
                    className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                    type="button"
                    onClick={handleCloseFormModal}
                    disabled={isLoading}
                  >
                    બંધ કરો
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateFormNew;
